import type { Colors } from '@/types/styles';

// TODO refactor
const otherColors = {
  lxc: {
    dark: '#0a4599',
    blue: '#0087dd',
    navyBlue: '#0054a6',
    purple: '#942483',
    orange: '#ff8f30',
    red: '#eb0000',
    darkBlue: '#1f4a9f',
  },
  border: {
    default: '#e0e0e0',
    gray: '#d1d5db',
    input_border: '#ced4da',
  },
  sidebar: {
    background: '#e6f3fc',
    text: '#0087dd',
  },
  calendar: {
    hGrid: '#e6f3fc',
    currentTime: '#0087dd',
    currentDay: '#e5f3fc',
    currentDayHGrid: '#cde9fb',
    text: '#5a5a5a',
    dlsTime: '#EA580C',
    dlsDay: '#fff7ed',
    dlsDayHGrid: 'rgba(253,186,116,0.3)',
  },
  backdrop: {
    background: '#c4c4c430',
  },
  med_grey: '#ADB5BD',
  gray: '#bdbdbd',
  gray_700: '#374151',
  dark_grey: '#57616B',
  light_grey: '#D9D9D9',
  light_grey_border: '#dadee1',
  bg_warning: '#FFAB07',
  punch_red: '#DC3545',
  punch_red_20: 'rgba(220,53,69,0.2)',
  danger_red: '#EB5757',
  success_green: '#28A745',
  orange: '#E89943',
  platform_blue: '#135188',
  live_blue: '#008ACD',
  white: '#ffffff',
  black: '#000000',
  outer_space: '#243342',
  medium_grey: '#7E8A96',
  light_blue: '#7899C5',
  pearl: '#f5f5f5',
} as const;

const colors: Colors = {
  gray: {
    c900: '#111827',
    c800: '#1f2937',
    c700: '#374151',
    c600: '#4b5563',
    c500: '#6b7280',
    c400: '#9ca3af',
    c300: '#d1d5db',
    c200: '#e5e7eb',
    c100: '#f3f4f6',
    c50: '#f9fafb',
  },
  green: {
    c900: '#064e3b',
    c800: '#065f46',
    c700: '#047857',
    c600: '#059669',
    c500: '#10b981',
    c400: '#34d399',
    c300: '#6ee7b7',
    c200: '#a7f3d0',
    c100: '#d1fae5',
    c50: '#ecfdf5',
  },
  orange: {
    c900: '#7c2d12',
    c800: '#9c4221',
    c700: '#c2410c',
    c600: '#ea580c',
    c500: '#f97316',
    c400: '#ff9843',
    c300: '#fdba74',
    c200: '#fed7aa',
    c100: '#ffedd5',
    c50: '#fff7ed',
  },
  purple: {
    c900: '#591d95',
    c800: '#553c9a',
    c700: '#8028d9',
    c600: '#933de9',
    c500: '#a05cf6',
    c400: '#a78bfa',
    c300: '#c4b5fd',
    c200: '#ddd6fe',
    c100: '#ede9fe',
    c50: '#f5f3ff',
  },
  blue: {
    c900: '#1e3a8a',
    c800: '#1e47af',
    c700: '#1d5dd8',
    c600: '#2574eb',
    c500: '#3b82f6',
    c400: '#60a5fa',
    c300: '#93c5fd',
    c200: '#bfdbfe',
    c100: '#dbeafe',
    c50: '#eff6ff',
  },
  pink: {
    c900: '#831843',
    c800: '#9d174d',
    c700: '#be185d',
    c600: '#db2777',
    c500: '#ec4899',
    c400: '#f472b6',
    c300: '#f9a8d4',
    c200: '#fbcfe8',
    c100: '#fce7f3',
    c50: '#fdf2f8',
  },
  red: {
    c900: '#7f1d1d',
    c800: '#991b1b',
    c700: '#b91c1c',
    c600: '#dc2626',
    c500: '#ef4444',
    c400: '#f87171',
    c300: '#fca5a5',
    c200: '#fecaca',
    c100: '#fee2e2',
    c50: '#fef2f2',
  },
  gold: {
    c900: '#544527',
    c800: '#6a5835',
    c700: '#876e3e',
    c600: '#9f834b',
    c500: '#af9259',
    c400: '#c3a76f',
    c300: '#c8b38b',
    c200: '#dcceb4',
    c100: '#e5dfd1',
    c50: '#f2efea',
  },
  silver: {
    c900: '#304547',
    c800: '#445c5e',
    c700: '#5a7678',
    c600: '#709496',
    c500: '#88aaac',
    c400: '#9db9bb',
    c300: '#b3cbcf',
    c200: '#c2d6d9',
    c100: '#dbe5e8',
    c50: '#ebf1f3',
  },
  teal: {
    c900: '#304747',
    c800: '#285e61',
    c700: '#5a7873',
    c600: '#709692',
    c500: '#14b8a6',
    c400: '#2dd4bf',
    c300: '#5eead4',
    c200: '#99f6e4',
    c100: '#ccfbf1',
    c50: '#f0fdfa',
  },
  yellow: {
    c900: '#78350f',
    c800: '#92400e',
    c700: '#b45309',
    c600: '#d97706',
    c500: '#f59e0b',
    c400: '#fbbf24',
    c300: '#fcd34d',
    c200: '#fde68a',
    c100: '#fef3c7',
    c50: '#fffbeb',
  },
  cyan: {
    c900: '#164e63',
    c800: '#155e75',
    c700: '#0e7490',
    c600: '#0891b2',
    c500: '#06b6d4',
    c400: '#22d3ee',
    c300: '#67e8f9',
    c200: '#a5f3fc',
    c100: '#cffafe',
    c50: '#ecfeff',
  },
  indigo: {
    c900: '#302e81',
    c800: '#3730a3',
    c700: '#4c38ca',
    c600: '#5c46e5',
    c500: '#6366f1',
    c400: '#818cf8',
    c300: '#a5b4fc',
    c200: '#c7d2fe',
    c100: '#e0e7ff',
    c50: '#eef2ff',
  },
  olive: {
    c900: '#2d4e13',
    c800: '#335e11',
    c700: '#3c760f',
    c600: '#59940d',
    c500: '#84b814',
    c400: '#9fd42d',
    c300: '#b5ea5e',
    c200: '#c7f699',
    c100: '#e1fbcc',
    c50: '#f2fdf0',
  },
  rose: {
    c900: '#881337',
    c800: '#9f1239',
    c700: '#be123c',
    c600: '#e11d48',
    c500: '#f43f5e',
    c400: '#fb7185',
    c300: '#fda4af',
    c200: '#fecdd3',
    c100: '#ffe4e6',
    c50: '#fff1f2',
  },
  lightBlue: {
    c900: '#0c4a6e',
    c800: '#075985',
    c700: '#0369a1',
    c600: '#0284c7',
    c500: '#0ea5e9',
    c400: '#38bdf8',
    c300: '#7dd3fc',
    c200: '#bae6fd',
    c100: '#e0f2fe',
    c50: '#f0f9ff',
  },
} as const;

export { colors, otherColors };
